import { UploadProvider } from '@components/Files/UploadProvider';
import { S3SignedUrlUploader } from 'app/features/uploads/S3SignedUrlUploader';
import { useJobUploadParamsMutation } from 'app/features/uploads/useJobUploadParamsMutation';
import { BulkCreateJobsModalContent } from './content';
import { ModalProvider } from './providers/ModalProvider';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
};

export const BulkCreateJobsModal = ({ onCancel, onSuccess }: TProps) => {
  const generateUploadParams = useJobUploadParamsMutation();
  return (
    <UploadProvider
      config={{
        mode: 'deferred',
        uploader: S3SignedUrlUploader(generateUploadParams),
      }}
    >
      <ModalProvider onCancel={onCancel} onSuccess={onSuccess}>
        <ModalWrapper width="500px">
          <ModalTitle>Bulk Job Creation</ModalTitle>
          <Content>
            <BulkCreateJobsModalContent />
          </Content>
        </ModalWrapper>
      </ModalProvider>
    </UploadProvider>
  );
};
